const rankingItems = [
  { rank: 1, title: '《暗夜追踪》2026最新动作悬疑大片', heat: '本周最热', icon: 'ri-fire-fill' as const, trend: 'up' },
  { rank: 2, title: '《欢乐喜剧人》第十季全集更新中', heat: '热度飙升', icon: 'ri-arrow-up-fill' as const, trend: 'up' },
  { rank: 3, title: '《深海秘境》4K纪录片震撼上线', heat: '新晋热门', icon: 'ri-star-fill' as const, trend: 'new' },
  { rank: 4, title: '《星辰变》第二季动画全集放送', heat: '稳定热门', icon: 'ri-flashlight-fill' as const, trend: 'stable' },
  { rank: 5, title: '《都市夜话》情感综艺话题讨论', heat: '持续上升', icon: 'ri-arrow-up-fill' as const, trend: 'up' },
  { rank: 6, title: '《极限穿越》冒险真人秀首播', heat: '新片推荐', icon: 'ri-rocket-fill' as const, trend: 'new' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
            视频热度榜
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            实时更新最受关注的视频内容排名
          </p>
          <div className="space-y-3">
            {rankingItems.map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-4 bg-background-100 rounded-xl p-4 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div
                  className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl font-heading font-bold text-lg ${
                    item.rank === 1
                      ? 'bg-primary-500 text-white'
                      : item.rank === 2
                      ? 'bg-accent-500 text-white'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-white'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate">
                    {item.title}
                  </h3>
                </div>
                <div className="flex-shrink-0 flex items-center gap-1.5">
                  <span
                    className={`w-5 h-5 flex items-center justify-center rounded-full ${
                      item.trend === 'up'
                        ? 'bg-primary-100 text-primary-600'
                        : item.trend === 'new'
                        ? 'bg-accent-100 text-accent-600'
                        : 'bg-secondary-100 text-secondary-600'
                    }`}
                  >
                    <i className={`${item.icon} text-xs`}></i>
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}